class FAQContent extends HTMLElement {
  constructor() {
    super();

    this.tabsSection = this.closest("tabs-wrapper");
    this.activeTab = this.tabsSection.querySelector(".tabs__tab--active");
    this.questions = this.querySelectorAll(".js-question");
    this.answers = this.querySelectorAll(".js-answer");
    this.isDesktop = window.matchMedia("(min-width: 990px)").matches;

    this.addListeners();
  }

  addListeners() {
    if (this.isDesktop) {
      this.initialLoad();
      this.questions.forEach((question) =>
        question.addEventListener("click", () => this.toggleContent(question))
      );
      subscribe(PUB_SUB_EVENTS.tabOpen, ({ tab }) => this.initialLoad(tab));
    }
  }

  toggleContent(question) {
    const link = question.dataset.link;

    if (!link) return;

    const linkedAnswer = this.querySelector(`.js-answer[data-link="${link}"]`);

    if (!linkedAnswer) return;

    this.reset();

    linkedAnswer.classList.remove("hidden");
    question.classList.add("faq__question--active");
  }

  initialLoad(tab) {
    const currentTab = tab ?? this.activeTab;

    const firstFaq = this.querySelector(
      `[data-content="${currentTab.dataset.tab}"] .js-question`
    );
    if (!firstFaq) return;
    firstFaq.classList.add("faq__question--active");

    this.toggleContent(firstFaq);
  }

  reset() {
    this.answers.forEach((answer) => answer.classList.add("hidden"));
    this.questions.forEach((question) =>
      question.classList.remove("faq__question--active")
    );
  }
}

customElements.define("faqs-content", FAQContent);
